import {
  InputGroup,
  type InputGroupProps
} from '@chakra-ui/react';

export type UiInputGroupProps = InputGroupProps;

export const UiInputGroup = InputGroup;
